import { useEffect, useState } from 'react'
import { Loader2, RefreshCw, Search } from 'lucide-react'
import api from '../../utils/api'

export default function UserReminderCashbackWithdrawalsTab() {
  const [loading, setLoading] = useState(false)
  const [submittingId, setSubmittingId] = useState(0)
  const [records, setRecords] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const [phone, setPhone] = useState('')
  const [statusInput, setStatusInput] = useState('')
  const [status, setStatus] = useState('')
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 1 })

  const fetchData = async (page = 1, targetPhone = phone, targetStatus = status) => {
    const trimmedPhone = String(targetPhone || '').trim()
    const trimmedStatus = String(targetStatus || '').trim()
    setPhone(trimmedPhone)
    setStatus(trimmedStatus)
    setLoading(true)
    try {
      const response = await api.get('/admin/user-reminder-cashback-withdrawals', {
        params: {
          phone: trimmedPhone,
          status: trimmedStatus || undefined,
          page,
          limit: pagination.limit
        }
      })
      if (response.data.success) {
        const data = response.data.data || response.data || {}
        const pager = data.pagination || response.data.pagination || {}
        setRecords(data.list || response.data.list || [])
        setPagination((prev) => ({
          page: pager.page || 1,
          limit: pager.limit || prev.limit,
          total: pager.total || 0,
          totalPages: pager.totalPages || 1
        }))
      }
    } catch (error) {
      console.error('获取用户弹窗提现申请失败:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(1, '', '')
  }, [])

  const handleAction = async (record, action) => {
    const actionTextMap = {
      approve: '确认审核通过该提现吗？',
      reject: '确认拒绝该提现吗？',
      'mark-paid': '确认标记该笔为已打款吗？'
    }
    const remarkPromptMap = {
      approve: '审核备注（可空）',
      reject: '拒绝备注（建议填写）',
      'mark-paid': '打款备注（可空）'
    }
    if (!window.confirm(actionTextMap[action] || '确认执行操作吗？')) {
      return
    }
    const remark = window.prompt(remarkPromptMap[action], '') || ''
    setSubmittingId(record.id)
    try {
      const response = await api.post(`/admin/user-reminder-cashback-withdrawals/${record.id}/${action}`, {
        remark
      })
      if (response.data.success) {
        const successTextMap = {
          approve: '审核通过成功',
          reject: '已拒绝该提现申请',
          'mark-paid': '已标记为已打款'
        }
        window.alert(successTextMap[action] || '操作成功')
        fetchData(pagination.page, phone, status)
      } else {
        window.alert(response.data.error || response.data.message || '操作失败')
      }
    } catch (error) {
      window.alert(error.response?.data?.error || error.response?.data?.message || '操作失败')
    } finally {
      setSubmittingId(0)
    }
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">用户弹窗提现申请</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            fetchData(1, searchInput, statusInput)
          }}
          className="flex flex-wrap items-center gap-2"
        >
          <div className="relative min-w-[220px]">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="手机号搜索"
              className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>
          <select
            value={statusInput}
            onChange={(e) => setStatusInput(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >
            <option value="">全部状态</option>
            <option value="pending">待审核</option>
            <option value="approved">已审核</option>
            <option value="rejected">已拒绝</option>
            <option value="paid">已打款</option>
          </select>
          <button type="submit" className="rounded-lg bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700">查询</button>
          <button
            type="button"
            onClick={() => {
              setSearchInput('')
              setStatusInput('')
              fetchData(1, '', '')
            }}
            className="rounded-lg bg-gray-100 px-4 py-2 text-sm text-gray-700 hover:bg-gray-200"
          >
            重置
          </button>
          <button
            type="button"
            onClick={() => fetchData(pagination.page, phone, status)}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm hover:bg-gray-50"
          >
            <RefreshCw className="h-4 w-4" />
            刷新
          </button>
        </form>
      </div>

      {loading ? (
        <div className="flex items-center justify-center rounded-xl border border-gray-200 bg-white py-12">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        </div>
      ) : (
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">申请时间</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">手机号</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">路线</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">金额</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">微信授权</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">状态</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">审核/打款</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {records.length > 0 ? records.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm text-gray-900">{item.created_at || '-'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{item.phone || '-'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{item.route_label || item.route_key || '-'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{item.amount ?? '-'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{item.wechat_nickname || item.wechat_openid || '-'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{item.status_label || item.status || '-'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{item.paid_at || item.reviewed_at || '-'}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={7} className="px-6 py-10 text-center text-sm text-gray-500">暂无提现申请</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="flex items-center justify-between bg-gray-50 px-6 py-4">
            <div className="text-sm text-gray-600">共 {pagination.total} 条，第 {pagination.page}/{pagination.totalPages} 页</div>
            <div className="flex items-center gap-2">
              <button
                disabled={pagination.page <= 1}
                onClick={() => fetchData(pagination.page - 1, phone, status)}
                className="rounded-lg border border-gray-300 px-3 py-1 disabled:opacity-50"
              >
                上一页
              </button>
              <button
                disabled={pagination.page >= pagination.totalPages}
                onClick={() => fetchData(pagination.page + 1, phone, status)}
                className="rounded-lg border border-gray-300 px-3 py-1 disabled:opacity-50"
              >
                下一页
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
